module.exports = __webpack_public_path__ + "img/GLPR_TKL_Trad2.ef49cdbf.svg";